class InvestorGoalEntity {
    id;
    type;
    plan;
    name;
    timeInYears;
    monthlyInvestmentAmount;
    amount;
    accountValue;
    isActive;
    isCompleted;
    lastMonthRentIncome;
    investmentRequiredAmount;
    progress;
    createdAt;
    timeWithoutReinvestment;
    timeWithReinvestment;
    timeToGoalReductionWithReinvestment;
    constructor(data) {
        this.id = data.id;
        this.type = data.type;
        this.plan = data.plan;
        this.name = data.name;
        this.timeInYears = data.timeInYears;
        this.monthlyInvestmentAmount = data.monthlyInvestmentAmount;
        this.amount = data.amount;
        this.accountValue = data.accountValue;
        this.isActive = data.isActive;
        this.isCompleted = data.isCompleted;
        this.lastMonthRentIncome = data.lastMonthRentIncome;
        this.investmentRequiredAmount = data.investmentRequiredAmount;
        this.progress = data.progress;
        this.createdAt = new Date(data.createdAt);
        this.timeWithReinvestment = data.timeWithReinvestment;
        this.timeWithoutReinvestment = data.timeWithoutReinvestment;
        this.timeToGoalReductionWithReinvestment = data.timeToGoalReductionWithReinvestment;
    }
}
export default InvestorGoalEntity;
